import { type FunctionComponent } from 'react';
import { bootstrapGridCompat } from './product-description.css';

export type ProductDescriptionProps = { description: string };

export const ProductDescription: FunctionComponent<ProductDescriptionProps> = ({ description }) => (
	<div
		data-testid={'ProductDescription'}
		className={`lh-copy ${bootstrapGridCompat}`}
		dangerouslySetInnerHTML={{
			__html: description
		}}
	/>
);
